module.exports = __webpack_public_path__ + "media/images/custom_page/ab6ix_event/ab6ix-event-ja-336d914f9dbc36cfff57645a614727d2.png";